import { formatTokenAmountForDisplay } from "@/utils";
import { DialogContent, LockForm, Divider, DialogAwareContentContainer } from "@/components";
import { TokenAmount } from "@/components";
import { type LockTokenId, TOKEN_IDS } from "@/types";
import { useLockPositions } from "@/hooks";

export interface LockMoreFormDialogProps {
    onClose?: () => void;
    existingDuration: number;
    initialTokenId?: LockTokenId;
}

export function LockMoreFormDialog({ existingDuration, initialTokenId }: LockMoreFormDialogProps) {
    const { lockedPositions } = useLockPositions();
    const exitingLockPosition = lockedPositions?.find((pos) => pos.lockDuration === `${existingDuration}w`);

    if (!exitingLockPosition) {
        console.error(
            "No existing lock position found for duration:",
            existingDuration,
            "and tokenId:",
            initialTokenId,
        );
        return (
            <DialogContent>
                <div className="text-red-500">Error: No existing lock position found.</div>
            </DialogContent>
        );
    }

    return (
        <DialogContent>
            <DialogAwareContentContainer isDialog>
                <div className="flex justify-between items-center">
                    <div className="text-gray-400">Existing lock</div>
                    <TokenAmount
                        amount={formatTokenAmountForDisplay(exitingLockPosition.lockedBalance)}
                        tokenId={initialTokenId ?? TOKEN_IDS.IUSD}
                    />
                </div>
                <div className="flex justify-between items-center mb-1">
                    <div className="text-gray-400">Duration</div>
                    <div>{existingDuration} weeks</div>
                </div>
                <Divider />
                <span className="mb-1" />
            </DialogAwareContentContainer>

            <LockForm
                isDialog
                tokenInputLabel="Enter additional amount"
                initialDuration={existingDuration}
                hideDurationSelector
                hideProjectedEarnings
            />
        </DialogContent>
    );
}
